import React from "react";
import {
  BiChevronRight,
  BiLogoLinkedin,
  BiLogoInstagram,
  BiLogoFacebook,
  BiLogoWhatsapp,
} from "react-icons/bi";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer id="footer">
        {/* <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <h4>Join Our Newsletter</h4>
              <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
              <form action="" method="post">
                <input type="email" name="email" /><input type="submit" value="Subscribe" />
              </form>
            </div>
          </div>
        </div>
      </div> */}

        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 footer-contact">
                <h3>WeLearn</h3>
                <p>
                  Plot no. 9, Chidanand Heights, <br />
                  opp. Rakshak Mart, Manish Nagar,
                  <br />
                  Nagpur, Maharashtra 440025
                  <br />
                  <br />
                  <strong>Phone:</strong> 712-3596237
                  <br />
                  <strong>Email:</strong> contact@welearn4u.com
                  <br />
                </p>
              </div>

              <div className="col-lg-4 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right">
                      <BiChevronRight />
                    </i>{" "}
                    <HashLink to="/#hero">Home</HashLink>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right">
                      <BiChevronRight />
                    </i>{" "}
                    <HashLink to="/#appfeatures">AppFeatures</HashLink>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right">
                      <BiChevronRight />
                    </i>{" "}
                    <HashLink to="/#gallery">Overview</HashLink>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right">
                      <BiChevronRight />
                    </i>{" "}
                    <Link onClick={scrollToTop} to="/termsofservices">
                      Terms of service
                    </Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right">
                      <BiChevronRight />
                    </i>{" "}
                    <Link onClick={scrollToTop} to="/privacypolicy">
                      Privacy policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 col-md-6 footer-links">
                <h4>Our Social Networks</h4>
                {/* <p>Cras fermentum odio eu feugiat lide par naso tierra videa magna derita valies</p> */}
                <div className="social-links mt-3">
                  <a href="linkedin" className="linkedin">
                    <i className="bx bxl-linkedin">
                      <BiLogoLinkedin />
                    </i>
                  </a>
                  <a href="/whatsapp" className="whatsapp">
                    <i className="bx bxl-twitter">
                      <BiLogoWhatsapp />
                    </i>
                  </a>
                  <a href="/facebook" className="facebook">
                    <i className="bx bxl-facebook">
                      <BiLogoFacebook />
                    </i>
                  </a>
                  <a href="/instagram" className="instagram">
                    <i className="bx bxl-instagram">
                      <BiLogoInstagram />
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container py-4 d-flex justify-content-center">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>WeLearn</span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </footer>
    </>
  );
}
